import { supabase } from '../supabase'

import { getDeviceFingerprint } from './deviceFingerprint'

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:8000'

export type RiskEventKind = 'signup' | 'login'

async function postRiskSignal(
  accessToken: string,
  eventKind: RiskEventKind,
  deviceFingerprint: string | null
): Promise<void> {
  await fetch(`${API_BASE_URL}/api/v1/risk/signals`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify({
      event_kind: eventKind,
      device_fingerprint: deviceFingerprint,
    }),
  })
}

export function reportRiskSignal(eventKind: RiskEventKind): void {
  void (async () => {
    const {
      data: { session },
    } = await supabase.auth.getSession()
    if (!session?.access_token) return

    const fingerprint = await getDeviceFingerprint()

    try {
      await postRiskSignal(session.access_token, eventKind, fingerprint)
    } catch {
      try {
        await postRiskSignal(session.access_token, eventKind, fingerprint)
      } catch {
        // fire-and-forget: auth UX must not depend on risk ingest
      }
    }
  })()
}
